import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function GarageIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M7 18V20H17V18L7 18Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7 14.5V16.6H17V14.5H7Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M7 11V13H17V11H7Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M21 8.57031V20H19V9.57031L12.6001 4.76953C12.2466 4.50586 11.7529 4.50586 11.3994 4.76953L5.00001 9.57007V20H3V8.5L5 7.07031L10.1997 3.16992C11.2607 2.375 12.7407 2.375 13.7998 3.16992L21 8.57031Z",
    fill: "currentColor"
  }));
}